
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type homeVehicleWidgetRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function homeVehicleWidgetRT(): TemplateResult<homeVehicleWidgetRTRootProps> {
    function repeatSelects1(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n        ', entry.value, '\n      ');
                }
                return _createElement('div', { 'className': this.extraClassName }, _createElement('div', { 'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown' }, this.index || this.index === 0 ? _createElement('span', {
                    'className': 'index',
                    'key': '117'
                }, this.index + 1) : null, _createElement.apply(this, [
                    'select',
                    {
                        'className': 'cm_select_inner-select cm_select__pretty',
                        'onChange': this.onChange,
                        'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                        'disabled': this.disabled
                    },
                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                        'value': '',
                        'key': 'null-option'
                    }, '\n        ', _translate(`select_title`), ' ', this.title, '\n      ') : null,
                    this.loading ? _createElement('option', {
                        'key': 'loading-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    _map(this.entries, repeatEntry1.bind(this))
                ])));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__home' }, this.template === 'active' ? _createElement('div', {
        'className': 'cm_vehicle-widget_dropdowns cm_mobile-hide cmTemplate_active',
        'key': '59'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects1.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_btn button button--small button--primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, '\n    ', this.name === 'HomeVehicleWidget' ? 'בחר את הרכב שלך' : 'בחר', '\n  '), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_btn button button--small button--secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button',
        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
    }, '\n    ', this.name === 'VehicleWidgetDialog' ? 'נקה' : 'איפוס', [_createElement('svg', {
            'className': 'cm_icon cm_icon-reset',
            'width': '20',
            'height': '20',
            'viewBox': '0 0 20 20',
            'fill': 'currentColor',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '28120'
        }, _createElement('path', {
            'd': 'M4.98866 15.1858C4.17305 14.4513 3.58467 13.5708 3.19919 12.6254C2.17663 10.1177 2.65545 7.13521 4.65186 5.07792L6.49409 6.92014C6.59553 7.02159 6.77813 6.94855 6.80248 6.79841L7.8088 0.21267C7.82503 0.103111 7.7317 0.00978219 7.62214 0.0260132L1.03234 1.03234C0.882207 1.05668 0.809167 1.23928 0.910611 1.34073L2.75689 3.18701C-0.290485 6.30336 -0.809878 10.9779 1.1906 14.6299C1.79114 15.7295 2.62298 16.7359 3.68206 17.5799C5.4837 19.0123 7.69924 19.698 9.89854 19.6534L10.3124 16.9469C8.41746 17.1092 6.46974 16.5249 4.98866 15.1858Z',
            'fill': 'currentColor'
        }), _createElement('path', {
            'd': 'M17.2431 16.813C20.2905 13.6966 20.8098 9.02206 18.8094 5.37008C18.2088 4.27043 17.377 3.2641 16.3179 2.42009C14.5163 0.987699 12.3007 0.301938 10.1014 0.346574L9.68753 3.0531C11.5784 2.89079 13.5302 3.4751 15.0113 4.81417C15.8269 5.54862 16.4153 6.42915 16.8008 7.37461C17.8233 9.8823 17.3445 12.8648 15.3481 14.922L13.5059 13.0798C13.4044 12.9784 13.2218 13.0514 13.1975 13.2016L12.1912 19.7873C12.1749 19.8969 12.2683 19.9902 12.3778 19.9739L18.9676 18.9676C19.1178 18.9433 19.1867 18.7607 19.0894 18.6592L17.2431 16.813Z',
            'fill': 'currentColor'
        }))])))) : null, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_btn button button--small button--primary  cm_desktop-hide',
        'onClick': this.openDialog,
        'role': 'button',
        'tabIndex': '0'
    }, '\n    ', this.name === 'HomeVehicleWidget' ? 'בחר את הרכב שלך' : 'בחר', '\n  '));
}
        export const componentNames = []